import { api } from './api';

// Define a service using a base URL and expected endpoints
export const promptApi = api.injectEndpoints({
  reducerPath: 'promptApi',
  tagTypes: ['Prompts'],
  endpoints: (builder) => ({
    getPrompts: builder.query({
      query: () => ({
        url: `/api/administration/prompts`,
        method: 'GET'
      }),
      providesTags: ['Prompts']
    }),
    createPrompt: builder.mutation({
      query: (promptRequest) => ({
        url: `/api/administration/prompts`,
        method: 'POST',
        body: promptRequest
      }),
      invalidatesTags: ['Prompts']
    }),
    updatePrompt: builder.mutation({
      query: ({ id, promptRequest }) => ({
        url: `/api/administration/prompts/${id}`,
        method: 'PATCH',
        body: promptRequest
      }),
      invalidatesTags: ['Prompts']
    }),
    deletePrompt: builder.mutation({
      query: (id) => ({
        url: `/api/administration/prompts/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Prompts']
    }),
    bulkDeletePrompts: builder.mutation({
      query: (ids) => ({
        url: `/api/administration/prompts`,
        method: 'DELETE',
        body: ids
      }),
      invalidatesTags: ['Prompts']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPromptsQuery,
  useCreatePromptMutation,
  useUpdatePromptMutation,
  useDeletePromptMutation,
  useBulkDeletePromptsMutation
} = promptApi;
